import apiClient from '../client';

export interface EmbeddingGenerationResponse {
  success: boolean;
  profileId: string;
  embeddingDimensions: number;
  estimatedTokens: number;
}

export const embeddingService = {
  /**
   * Generate embedding for a freelancer profile (admin only)
   * @param profileId - The freelancer profile UUID
   */
  generateProfileEmbedding: (profileId: string): Promise<EmbeddingGenerationResponse> =>
    apiClient.post<EmbeddingGenerationResponse>('/embeddings/generate', { profileId }) as unknown as Promise<EmbeddingGenerationResponse>,
};

